import options from './chart-touch.component';

export default {
    selector: 'dtChartTouch',
    options
};
